module.exports = __webpack_public_path__ + "img/high.b29cf0d5.svg";